import * as shariff from '../../../vendor/assets/javascripts/shariff.complete.js';

window.shariff = shariff;

var componentRequireContext = require.context('src', true);
var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);
